import { render, staticRenderFns } from "./create-appointment.vue?vue&type=template&id=5e36aa0d"
import script from "./create-appointment.vue?vue&type=script&lang=js"
export * from "./create-appointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports